<template>
  <v-dialog
    v-model="attendanceDialog"
    width="90%"
    @click:outside="closeOvertime"
  >
    <template v-slot:activator="{ on, attrs }">
      <p id="attendanceDialog" v-bind="attrs" v-on="on" @click="openDialog"></p>
    </template>
    <v-card
      style="padding: 10px 20px 20px 20px; position: relative"
      class="text-center"
    >
      <v-row>
        <v-col md="12" style="padding: 0">
          <v-card-title>
            <v-spacer> </v-spacer>LAPORAN PRESENSI<v-spacer> </v-spacer>
            <v-btn
              small
              icon
              color="red"
              style="color: white; position: absolute; top: 5px; right: 5px"
              @click="closeDialog"
            >
              <v-icon small>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-data-table
            mobile-breakpoint="0"
            fixed-header
            height="50vh"
            :headers="attendanceHeaders"
            style="cursor: pointer"
            :items="attendanceData"
            item-key="id"
            :footer-props="{
              showFirstLastPage: true,
              showCurrentPage: true,
              itemsPerPageOptions: [1, 3, 5, 10, 15, 100]
            }"
          >
            <template v-slot:[`item.date`]="{ item }">
              <div style="padding: 0; display: flex; flex-direction: row">
                {{
                  convertDateTime(item.date).slice(
                    0,
                    convertDateTime(item.date).indexOf(',')
                  )
                }}
              </div>
            </template>
            <template v-slot:[`item.clock_in`]="{ item }">
              <v-chip
                :color="getColorStatus(item.status_clock_in)"
                green
                style="cursor: pointer"
              >
                <div
                  v-if="item.clock_in !== null"
                  class="d-flex justify-center align-center"
                >
                  <span style="margin-right: 2px">{{
                    attendFrom(item.attend_from_in)
                  }}</span>
                  {{ convertDate2(item.clock_in_date) }}
                  {{ item.clock_in }}
                  <div
                    v-if="item.attend_from_in !== null"
                    style="margin-left: 2px"
                  >
                    <v-btn icon small>
                      <v-icon small color="primary">mdi-image</v-icon>
                    </v-btn>
                  </div>
                </div>
              </v-chip>
            </template>
            <template v-slot:[`item.clock_out`]="{ item }">
              <v-chip
                :color="getColorStatus(item.status_clock_out)"
                green
                style="cursor: pointer"
              >
                <div
                  v-if="item.clock_out !== null"
                  class="d-flex justify-center align-center"
                >
                  <span style="margin-right: 2px">{{
                    attendFrom(item.attend_from_out)
                  }}</span>

                  {{ convertDate2(item.clock_out_date) }}
                  {{ item.clock_out }}
                  <div
                    v-if="item.attend_from_out !== null"
                    style="margin-left: 2px"
                  >
                    <v-btn icon small>
                      <v-icon small color="primary">mdi-image</v-icon>
                    </v-btn>
                  </div>
                </div>
              </v-chip>
            </template>
            <template v-slot:[`item.shift_name`]="{ item }">
              <div style="padding: 0; display: flex; flex-direction: row">
                {{ item.shift_name }}
              </div>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'AttendanceDialog',
  props: ['attendanceData'],
  data() {
    return {
      attendanceDialog: false,
      isLoading: false
    }
  },
  computed: {
    attendanceHeaders() {
      return [
        {
          text: 'NIK',
          value: 'nik',
          sortable: false,
          align: 'left'
        },
        {
          text: 'Name',
          value: 'employee_name',
          sortable: false,
          align: 'left'
        },
        {
          text: 'Shift',
          value: 'shift_name',
          align: 'left',
          sortable: false
          // width: 150
        },
        {
          text: 'Date',
          value: 'date',
          align: 'left',
          sortable: false
          // width: 150
        },
        {
          text: 'Clock In',
          value: 'clock_in',
          align: 'left',
          sortable: false
        },
        {
          text: 'Clock Out',
          value: 'clock_out',
          align: 'left',
          sortable: false
        }
      ]
    }
  },
  methods: {
    openDialog() {
      console.log(this.attendanceData)
    },
    closeDialog() {
      this.attendanceDialog = false
    },
    convertDateTime(raw) {
      if (raw !== null) {
        const date = new Date(raw)
        const local = date.toLocaleString('id')
        return local
      } else {
        return '-'
      }
    },
    convertDate2(raw) {
      if (raw !== null) {
        const date = new Date(raw)
        const local = Intl.DateTimeFormat('id', {
          day: 'numeric',
          month: 'long'
        }).format(date)
        return local
      }
    },
    closeOvertime() {
      this.attendanceDialog = false
    },

    attendFrom(val) {
      switch (val) {
        case 1:
          return 'Kantor:'
        case 2:
          return 'Lain-lain:'
        case 3:
          return 'Rumah:'
        default:
          return 'Thermal:'
      }
    },
    getColorStatus(pStatus) {
      if (pStatus === 'on_time' || pStatus === 'go_after_time') {
        return ''
      } else if (pStatus === 'late' || pStatus === 'go_before_time') {
        return 'red'
      }
    }
  }
}
</script>

<style></style>
